import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import Chargers from "../components/Chargers"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "sub-visual.jpg" }) {
      childImageSharp {
        fluid(quality: 70, maxWidth:1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Instrukcja = () => {
    const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | OUR CHARGERS" />
      <Sublinks />

      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-ladowarki`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div
          className="visual-content col-md-8 ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <div className="title text-center">OUR CHARGERS</div>
          <p className="font-xxl font-light text-center">
            The ORLEN network provides drivers with access to chargers
            supplied by three manufacturers: Ekoenergetyka, ABB and Efacec.
            All chargers on the ORLEN network are equipped with three connector
            types: two DC connectors (CCS and CHAdeMO) and one AC connector
            (Type 2). Most of our chargers are located at ORLEN service
            stations.
          </p>
        </div>
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
      </BackgroundImage>
      <Chargers />
    </Layout>
  )
}
export default Instrukcja



